import { Fragment } from 'react';

export const ErrorLoader = () => () => {
  location.href = 'https://www.plaync.com/error/500'; // plaync error 페이지로 가도록

  return null;
};

const Error = () => {
  return <Fragment></Fragment>;
};

export default Error;
